<template>
  <div>
    <el-date-picker
        v-model="query.days"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择节日日期"
        size="mini"
    >
    </el-date-picker>
    <el-input class="search-el" size="mini" v-model="query.keyword" placeholder="请节目名称"></el-input>
    <el-button type="primary" size="mini" @click="getListQuery()">
      查询
    </el-button>
    <el-button type="primary" size="mini" @click="toCreate(0)">
      添加
    </el-button>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column
            prop="days"
            label="节目日期"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column label="播放起止时间" align="center" width="180">
          <template slot-scope="{ row }">
            <div>开始时间： {{ row.begin_at }}</div>
            <div>结束时间： {{ row.end_at }}</div>
          </template>
        </el-table-column>

        <el-table-column
            label="节目单"
            align="center"
            min-width="40%"
        >
          <template slot-scope="{ row }">
            <span v-for="(orderItems, index) in row.title_arr"
                  :key="index">
            {{ orderItems }}
            <br />
          </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="mini"
                @click="toCreate(row.id)"
            >
              编辑
            </el-button>

            <el-button
                type="text"
                size="small"
                @click="deleteFm(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {getRadioFmList, radioFmDelete} from "@/api/radioFm";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        days: "",
        keyword: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toCreate(id) {
      this.$router.push({
        path: "/radioFm/info",
        query: {
          id: id
        }
      });
    },

    getListQuery(){
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.loading = true;
      getRadioFmList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    deleteFm(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        radioFmDelete({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {

  },
};
</script>